"use client";

/**
 * NewForm DS hover icon — an arrow dropping to a line, for "jump to latest".
 * On hover the arrow hops down toward the line and returns; the line holds
 * still, so the motion reads as travelling to the end rather than the whole
 * glyph sliding.
 * See ./hoverIcon for the colour/animation conventions.
 */

import { type HoverIconProps, HoverIconSvg } from "./hoverIcon";

export function JumpDownIcon({ size, className }: HoverIconProps) {
  return (
    <HoverIconSvg size={size} className={className}>
      <g className="a-jump">
        <path d="M12 4.2v10.2" />
        <path d="m7.7 10.3 4.3 4.3 4.3-4.3" />
      </g>
      <path d="M6.2 19.4h11.6" />
    </HoverIconSvg>
  );
}
